import '../../utils/index.mjs';
import Autocomplete from './src/autocomplete2.mjs';
export { autocompleteEmits, autocompleteProps } from './src/autocomplete.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAutocomplete = withInstall(Autocomplete);

export { ElAutocomplete, ElAutocomplete as default };
//# sourceMappingURL=index.mjs.map
